import { Caption1 } from '@fluentui/react-components';
import type { ReactNode } from 'react';
import { useStyles } from './_styles.js';

type CardNoteProps = {
    icon: JSX.Element;
    children: ReactNode;
};

/** Closing remark of a card, set apart from the main copy by an icon. */
export function CardNote({ icon, children }: CardNoteProps) {
    const styles = useStyles();

    return (
        <div className={styles.note}>
            <span className={styles.noteIcon}>{icon}</span>
            <Caption1 className={styles.noteText}>{children}</Caption1>
        </div>
    );
}
